import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { ConfigurationService } from './configuration.service';

export const Ng1ConfigurationModule = angular
  .module('control-room.angular.configuration', [])
  .factory('crConfigurationService', downgradeInjectable(ConfigurationService));
